import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";

// Generic function to initialize a dropdown
function initializeDropdown(dropdownElement) {
  const submenu = dropdownElement.querySelector(".js-submenu");

  if (!submenu) return;

  // The dropdownElement itself (e.g., <li> or <div> with .js-dropdown) is the trigger
  dropdownElement.addEventListener("click", function (event) {
    // If the actual click target is within the submenu, do nothing here.
    // The submenu's own click handler (below) will stop propagation.
    if (submenu.contains(event.target)) {
      return;
    }
    event.stopPropagation();

    const isActive = this.classList.contains("is-active");

    // Close all other currently open .js-dropdowns first
    document
      .querySelectorAll(".js-dropdown.is-active")
      .forEach((openDropdown) => {
        if (openDropdown !== this) {
          // 'this' is the current dropdownElement
          openDropdown.classList.remove("is-active");
          const openSub = openDropdown.querySelector(".js-submenu");
          if (openSub) {
            openSub.classList.add("hidden");
          }
        }
      });

    // Then toggle the current one
    if (isActive) {
      this.classList.remove("is-active");
      submenu.classList.add("hidden");
    } else {
      this.classList.add("is-active");
      submenu.classList.remove("hidden");
    }
  });

  // Prevent clicks within the submenu from closing the dropdown immediately
  // or bubbling up to document click listener undesirably.
  submenu.addEventListener("click", function (event) {
    event.stopPropagation();
  });
}

// Global click listener to close dropdowns when clicking outside
let globalClickListenerAdded = false;
function addGlobalClickListenerForDropdowns() {
  if (globalClickListenerAdded) return;
  document.addEventListener("click", (event) => {
    document.querySelectorAll(".js-dropdown.is-active").forEach((dropdown) => {
      if (!dropdown.contains(event.target)) {
        dropdown.classList.remove("is-active");
        const submenu = dropdown.querySelector(".js-submenu");
        if (submenu) {
          submenu.classList.add("hidden");
        }
      }
    });
  });
  globalClickListenerAdded = true;
}

export default function nav() {
  const header = document.querySelector(".js-header");
  const mainNavContainer = document.querySelector(".js-nav");
  const hamburger = document.querySelector(".js-hamburger");

  // Initialize all dropdowns with .js-dropdown class
  const allDropdowns = document.querySelectorAll(".js-dropdown");
  allDropdowns.forEach((dropdownEl) => {
    initializeDropdown(dropdownEl);

    // Specific adjustments for dropdowns within the main navigation
    if (mainNavContainer && mainNavContainer.contains(dropdownEl)) {
      const submenu = dropdownEl.querySelector(".js-submenu");
      if (submenu && header) {
        // This positions main nav submenus below the header bar
        submenu.style.top = `${header.clientHeight}px`;
      }
    }
  });

  // Add the global click listener for closing dropdowns
  if (allDropdowns.length > 0) {
    addGlobalClickListenerForDropdowns();
  }

  // Hamburger menu logic
  if (hamburger && mainNavContainer) {
    hamburger.addEventListener("click", (event) => {
      event.stopPropagation();
      hamburger.classList.toggle("is-active");
      mainNavContainer.classList.toggle("cloaked");
      if (mainNavContainer.classList.contains("cloaked")) {
        enableBodyScroll(mainNavContainer);
      } else {
        disableBodyScroll(mainNavContainer);
      }
    });

    // Close mobile nav if clicking outside of it or its toggle
    document.addEventListener("click", (event) => {
      if (
        hamburger.classList.contains("is-active") &&
        !mainNavContainer.contains(event.target) &&
        !hamburger.contains(event.target)
      ) {
        hamburger.classList.remove("is-active");
        mainNavContainer.classList.add("cloaked");
        enableBodyScroll(mainNavContainer);
      }
    });
  }
}
